/**
 * GutschriftPDF — kurumsal Gutschrift belgesi (gemeinsamer Briefkopf/Fuß,
 * Schlusstext aus der Dokumentvorlage „gutschrift“).
 */
import {
  fetchPdfSettings, downloadPdfFromHtml, wrapPdfDocument,
  renderCompanyHeader, renderFooter, escapeHtml, formatDate, formatCurrency,
} from '@/lib/pdfRenderer';
import { getVorlage, textZuHtml } from '@/lib/dokumentVorlagen';

/** Gövde HTML (Vorschau + Download). */
export function buildGutschriftBody(gs, settings) {
  const vorlage = getVorlage(settings, 'gutschrift');
  const datum = formatDate(gs.created_at || new Date());
  const ctx = {
    'kunde.name': gs.lead_name || '', 'kunde.nummer': (gs.lead_id || '').substring(0, 4).toUpperCase(),
    'firma.name': settings.company_name, 'firma.geschaeftsfuehrer': settings.geschaeftsfuehrer, 'firma.ansprechpartner': settings.ansprechpartner,
    'beleg.nummer': gs.gutschrift_no || '', 'beleg.datum': datum, 'rechnung.nummer': gs.invoice_no || '',
  };
  const rows = (gs.items || []).map((it, i) => `
    <tr>
      <td style="padding:8px;border-bottom:1px solid #eee;text-align:center">${i + 1}</td>
      <td style="padding:8px;border-bottom:1px solid #eee">${escapeHtml(it.product_name || '')}</td>
      <td style="padding:8px;border-bottom:1px solid #eee;text-align:right">${it.quantity}</td>
      <td style="padding:8px;border-bottom:1px solid #eee;text-align:right">${formatCurrency(it.unit_price)}</td>
      <td style="padding:8px;border-bottom:1px solid #eee;text-align:right;font-weight:700">−${formatCurrency(it.total)}</td>
    </tr>`).join('');
  const schlussHtml = textZuHtml(vorlage.schluss, ctx);
  return `
    ${renderCompanyHeader(settings)}
    <div style="margin-bottom:20px">
      <h1 style="font-size:20px;margin:0 0 4px 0;color:#b45309">GUTSCHRIFT</h1>
      <div style="color:#666;font-size:11px">
        Nummer: ${escapeHtml(gs.gutschrift_no || '')} · Datum: ${datum}
        · zu Rechnung ${escapeHtml(gs.invoice_no || '')}
      </div>
    </div>
    <div style="font-size:12px;font-weight:700;margin-bottom:14px">${escapeHtml(gs.lead_name || '')}</div>
    <table style="width:100%;border-collapse:collapse;font-size:11px;margin-bottom:16px">
      <thead><tr style="background:#1e293b;color:#fff">
        <th style="padding:8px;font-size:10px;width:36px">#</th>
        <th style="padding:8px;text-align:left;font-size:10px">Artikel</th>
        <th style="padding:8px;text-align:right;font-size:10px;width:60px">Menge</th>
        <th style="padding:8px;text-align:right;font-size:10px;width:90px">Einzelpreis</th>
        <th style="padding:8px;text-align:right;font-size:10px;width:100px">Betrag</th>
      </tr></thead>
      <tbody>${rows}</tbody>
    </table>
    <table style="width:280px;margin-left:auto;border-collapse:collapse;font-size:11px">
      <tr><td style="padding:6px">Netto</td><td style="padding:6px;text-align:right">−${formatCurrency(gs.subtotal)}</td></tr>
      <tr><td style="padding:6px">USt.</td><td style="padding:6px;text-align:right">−${formatCurrency(gs.tax_amount)}</td></tr>
      <tr style="border-top:2px solid #111"><td style="padding:6px;font-weight:900">Gutschriftbetrag</td>
        <td style="padding:6px;text-align:right;font-weight:900">−${formatCurrency(gs.total)}</td></tr>
    </table>
    ${gs.reason ? `<p style="font-size:11px;color:#555;margin-top:14px">Grund: ${escapeHtml(gs.reason)}</p>` : ''}
    ${schlussHtml ? `<p style="font-size:11px;line-height:1.6;margin-top:14px">${schlussHtml}</p>` : ''}
    ${renderFooter(settings)}
  `;
}

export async function downloadGutschriftPdf(gs, customSettings) {
  const settings = customSettings || await fetchPdfSettings();
  await downloadPdfFromHtml(wrapPdfDocument(buildGutschriftBody(gs, settings), `Gutschrift ${gs.gutschrift_no}`), gs.gutschrift_no);
}

export default { buildGutschriftBody, downloadGutschriftPdf };
